var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAngleRight16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.489 14.671a1.25 1.25 0 0 1-.16-1.76l2.87-4.314c.213-.32.32-.48.361-.653a1 1 0 0 0 0-.466c-.041-.173-.148-.333-.36-.653L4.328 2.51a1.25 1.25 0 1 1 1.92-1.6c.403.483 2.415 2.956 3.9 4.78.584.72.876 1.08.988 1.48a2 2 0 0 1 0 1.079c-.113.4-.406.76-.992 1.479L6.25 14.511a1.25 1.25 0 0 1-1.76.16Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleRight16);
export default __webpack_public_path__ + "static/media/angle_right_16.f61a8645.svg";
export { ForwardRef as ReactComponent };